import React, { PropTypes, Component } from 'react'
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import Arrow from 'react-icons/lib/io/android-arrow-forward';
import PageTitle from '../pagescreen/pagetitle';
import Header from '../header';
import Footer from '../homescreen/footer';
import withPage from '../../containers/withpage';
import withMedia from '../../containers/withmedia';
import style from './style.css'


class News extends Component {

    constructor(props){
        super(props)
        this.grid = this.grid.bind(this)
    }

    grid(items){
        let widths = []
        let heights = []
        const is_large = this.props.browser && this.props.browser.greaterThan.small
        const count = this.props.count ? parseInt(this.props.count) : null
        const _items = (count && count > 0) ? items.slice(0, count ) : items
        return(
            <div className={ this.support("grid-template-rows") && !count ? style.grid : style.flex }>
            { _items.map((node,i) => {
                if(i % 2 === 0) { heights = [] }
                if(i % 3 === 0) { widths = []  }
                let w = 300 //parseInt(node.photo.width)
                let h = 200 //parseInt(node.photo.height)
                // console.log(w,h)
                let styles = {
                    gridColumn: (w > (1.5 * h)) && !widths.includes('span 2') ? 'span 2' : 'span 1',
                    gridRow: h > (w * 2/3 ) && !heights.includes('span 2') ? 'span 2' : ( parseInt(Math.random() * 2) % 2 == 1 ? 'span 2' : 'span 1'),
                    backgroundColor: '#f5f5f5'
                }
                widths.push(styles.gridColumn)
                heights.push(styles.gridRow)
                return( 
                <div className={ style.item } style={ styles } key={`newitem_${i}`} onClick={ () => { this.props.history.push(`/posts/${node.id}`) }}>
                        <div className={ style.overlay }><h3>{node.title }</h3>
                        <span className={ style.goto }>
                            <Arrow/>
                        </span>
                        </div>
                        <div className={ style.img }  style={ { backgroundImage: `url('${ node.photo_uri.replace('large', is_large ? 'gallery' : 'large') }')` }  }></div>
                    </div>  
                    )
                })}
            </div>
        )
    }

    /*
     * Return true if CSS property is supported by client browser
        * */
    support(prop){
        var div = document.createElement('div'),
            vendors = 'Khtml Ms O Moz Webkit'.split(' '),
            len = vendors.length;
            if ( prop in div.style ) return true;
            prop = prop.replace(/^[a-z]/, (val) => {
                return val.toUpperCase();
            })
            while(len--) {
                if ( vendors[len] + prop in div.style ) {
                    return true;
                } 
            }
            return false;
    }

    render() {
        const { highlights } = this.props
        const items = highlights
        // console.log(navigator.userAgent);
        // console.log(this.support("grid-template-rows") ? "Grid Supported!!" : "Grid Not Supported...")
        return (
            <div>
                    { items ? this.grid(items) : <div>...loading</div> }
            </div>
        )
    }
}
const fragment = `
            title
            slug
            blurb
            body
            short
            id
            db_id
            parent_id
            photo {
                photo_uri(size: "medium")
                title
            }
            children(order: "pages.lft asc") {
                title
                slug
                body
                db_id
                url_title
                photo {
                    photo_uri(size: "medium")
                    height
                    width
                }
            }
`

export default withMedia(withRouter(connect(s => ({ highlights: s.app.highlights }))(News)))



// WEBPACK FOOTER //
// ./src/components/news/list.js